import { lazy } from 'react'
import { getLinkObject } from './services/getLinkObject'
import { REPORTER_LINKS } from './projects/reporter/Reporter.const'
import { MEDIASTORAGE_LINKS } from './projects/mediaStorage/MediaStorage.const'
import { AGENT_LINKS } from './projects/agent/Agent.const'

const LINKS = {
  MAIN: {
    AUTHORIZATION: getLinkObject(
      '/start/authorization',
      'Authorization',
      lazy(() => import('./sections/authorization/Authorization'))
    ),
    AUTH_CONFIGURATOR: getLinkObject(
      '/auth_configurator',
      'AuthConfigurator',
      lazy(() => import('./sections/authConfigurator/AuthConfigurator'))
    ),
    START_PAGE: getLinkObject(
      '/start',
      'Start page',
      lazy(() => import('./sections/startPage/StartPage'))
    ),
    PROJECTS_PAGE: getLinkObject(
      '/',
      'Projects page',
      lazy(() => import('./sections/projectsPage/ProjectsPage'))
    ),
    NO_PAGE: getLinkObject(
      '/no_page',
      'No page found',
      lazy(() => import('@voicekey/components-base/noMatchRoutePage/NoMatchRoutePage'))
    ),
    DOCUMENTATION: getLinkObject(
      '/documentation',
      'Documentation',
      lazy(() => import('./sections/documentation/Documentation'))
    ),
    CONFIGURATOR: getLinkObject(
      '/configurator',
      'Configurator',
      lazy(() => import('./projects/configurator/components/init/Init'))
    ),
    SETTINGS: getLinkObject(
      '/settings',
      'Settings',
      lazy(() => import('./sections/settings/Settings'))
    )
  },
  APPLICATIONS: {
    MEDIASTORAGE: getLinkObject(
      '/mediastorage',
      'MediaStorage',
      lazy(() => import('./projects/mediaStorage/components/init/Init')),
      MEDIASTORAGE_LINKS
    ),
    TTS: getLinkObject(
      '/vktts',
      'TTS',
      lazy(() => import('./projects/tts/components/init/Init')),
      {}
    ),
    PERSON: getLinkObject(
      '/person',
      'Person',
      lazy(() => import('./projects/person/components/PersonsPanel'))
    ),
    TRACKER: getLinkObject(
      '/tracker',
      'Tracker',
      lazy(() => import('./projects/tracker/components/TrackerPanel'))
    ),
    SECURITY: getLinkObject(
      '/security',
      'Security',
      lazy(() => import('./projects/security/components/init/Init')),
      {}
    ),
    ASR: getLinkObject(
      '/asr',
      'Asr',
      lazy(() => import('./projects/asr/components/init/Init')),
      {}
    ),
    REPORTER: getLinkObject(
      '/reporter',
      'Reporter',
      lazy(() => import('./projects/reporter/components/init/Init')),
      REPORTER_LINKS
    ),
  }
}

export default LINKS

// TODO remove MODALITIES to const
// TODO remove endpoints to api

export const MODALITIES = {
  FACE: {
    name: 'face',
    getTemplateEndpoint: () => 'face/faces',
    getRegisterEndpoint: (profile, groupId) => {
      return 'processor/face/' + (profile ? profile + '/' : '') + groupId
    },
    getTransactionEndpoint: () => 'face/transaction',
    dataName: 'photo',
    mediaSrcName: 'photoSrc',
    dataType: 'PICTURE',
    fileInputData: {
      permissibleSizeMb: 5,
      MIMETypeBase: 'image',
      MIMESubTypes: ['png', 'jpeg']
    }
  },
  VOICE: {
    name: 'voice',
    getTemplateEndpoint: () => 'voice/voices',
    getRegisterEndpoint: (profile, groupId) => {
      return 'processor/freetext/' + (profile ? profile + '/' : '') + groupId
    },
    getTransactionEndpoint: () => 'voice/transaction',
    dataName: 'audio',
    mediaSrcName: 'audioSrc',
    dataType: 'SOUND',
    fileInputData: {
      permissibleSizeMb: 5,
      MIMETypeBase: 'audio',
      MIMESubTypes: ['wav']
    }
  }
}
